export default __webpack_public_path__ + "static/media/gift-white.32bb0791.png";